export enum DefinitionType {
    Series,
    Glossary,
}
